import React, {
    useContext, useState, useCallback, useMemo
} from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import _ from 'lodash';
import { ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { Table, TableColumn } from '@jutro/layout';
import { uwIssuesMessages } from 'gw-components-platform-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { messages as commonMessages } from 'gw-platform-translations';
import gatewayMessages from '../../gateway.messages';
import ErrorsUtil from './ErrorsUtil';
import metadata from './ErrorsComponent.metadata.json5';
import styles from './ErrorsComponent.module.scss';
import messages from './ErrorsComponent.messages';

const ErrorsAndWarningsTableComponent = (props) => {
    const { uwIssues, noRecordsMessage, uwUtil } = props;
    const translator = useContext(TranslatorContext);

    const getTableCell = useCallback((items, index, property) => {
            var propheader = property.header === 'Type' ? 'bmserrorMessageType' : 'message'
            return items[propheader];
        },
        []);

        const getColumns = useCallback(() => {
            if(uwIssues && uwIssues.length > 0){
                return Object.keys(uwIssues[0]).map(key => {
                    return {
                        columnHeader: key,
                    };
                });
            } else {
                return [];
            }
        }, [uwIssues]);


        const getTableColumns = useCallback(() => {
            const displayColumns = getColumns();
            let count = 0;
            const dynamicReactTable = displayColumns.map((displayColumn) => {
                const columnId = `col${count++}`;
                return (
                    <TableColumn
                        id={columnId}
                        textAlign="left"
                        header={displayColumn.columnHeader === 'bmserrorMessageType' ? 'Type' : 'Message'}
                        cell={getTableCell}
                    />
                );
            });
            return dynamicReactTable;
        }, [getColumns, getTableCell]);

    return (
        <Table data={uwIssues} placeholder={noRecordsMessage}>
            {getTableColumns()}
        </Table>
    );
};
ErrorsAndWarningsTableComponent.propTypes = {
    uwIssues: PropTypes.shape([]).isRequired,
    noRecordsMessage: PropTypes.string.isRequired,
    uwUtil: PropTypes.shape({
        offerings: PropTypes.shape([])
    }).isRequired
};

const ErrorsAndWarnngsComponent = (props) => {
    const {
        job,
        continueJob,
        onWithdrawJob,
        onEditJob,
        jobService,
        authUserData,
        authHeader,
        onUpdateJobSummary
    } = props;
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});
    const [showReferToUW, setShowReferToUW] = useState(false);

    const uwutil = useMemo(() => ErrorsUtil(job, authUserData.userType), []);

    const getCell = useCallback((items, index, property) => {
        return items[property.id];
    }, []);

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
        },
        [formData]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell: getCell,
            writeValue: writeValue
        },
        resolveComponentMap: {
            errorsWarningsTableComponent: ErrorsAndWarningsTableComponent,
        }
    };
    const overrideProps = {
        errorAndWarningIssues: {
            uwIssues: job.errorsAndWarnings_EY && job.errorsAndWarnings_EY.bmscustomMessages_EY && job.errorsAndWarnings_EY.bmscustomMessages_EY.length > 0 ? job.errorsAndWarnings_EY.bmscustomMessages_EY : [],
            uwUtil: uwutil,
            noRecordsMessage: translator(messages[`noOpenErrors${uwutil.jobType}`])
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={formData}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

ErrorsAndWarnngsComponent.propTypes = {
    authHeader: PropTypes.shape({
        Authorization: PropTypes.string
    }).isRequired,
    job: PropTypes.shape({
        statusCode: PropTypes.string,
        isEditLocked: PropTypes.bool,
        createdByMe: PropTypes.bool,
        jobNumber: PropTypes.number,
        underwritingIssues: PropTypes.shape({})
    }),
    continueJob: PropTypes.shape({
        isContinueTransaction: PropTypes.bool
    }),
    onWithdrawJob: PropTypes.func.isRequired,
    onUpdateJobSummary: PropTypes.func.isRequired,
    onEditJob: PropTypes.func.isRequired,
    jobService: PropTypes.shape({
        referToUnderwriter: PropTypes.string
    }).isRequired,
    authUserData: PropTypes.shape({
        userType: PropTypes.string
    }).isRequired
};
ErrorsAndWarnngsComponent.defaultProps = {
    job: {},
    continueJob: {}
};

export default withAuthenticationContext(ErrorsAndWarnngsComponent);
